import {config} from "@mobiusjs/site-client";

let prodConfig = {}
try {
    prodConfig = require('./config.prod').default
} catch (e) {
    console.log('No production config defined')
}

export default {
    ...config,
    options: require('./config.options').default(config.options),
    version: '2.0.0',
    debug: true,
    soon: false,
    prefix: 'tes_',
    name: 'tes_site',
    title: 'TourYup',
    description: "",
    robots: "noindex, nofollow",
    directives: {
        connectSrc: [],
        imgSrc: [],
        fontSrc: []
    },
    modules: {
        library: {...config.modules.library},
        custom: {}
    },
    projects: {
        single: true,
        default: 'touryup',
        projects: ['touryup']
    },
    lang: {
        multiLang: true,
        default: 'en',
        languages: ['az', 'en', 'ru']
    },
    curr: {
        multiCurr: true,
        default: 'usd',
        currencies: ['usd', 'eur', 'azn']
    },
    company: {
        //established: 2024,
        title: 'TourYup'
    },
    ssl: true,
    urls: {
        api: '',
        cdn: '',
        site: ''
    },
    routes: {
        hasStatic: true
    },
    settings: {
        promoCode: true,
        tips: true
    },
    ...prodConfig
}
